export const Logo = ({ size = 34, mono = true }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-label="Bodegón Demo" data-testid="logo-mark">
    <rect x="1.5" y="1.5" width="37" height="37" rx="7" fill="#A0CDE8" stroke="#0A0A0A" strokeWidth="2.2" />
    {/* tenedor */}
    <path d="M13 9v6.2c0 2 1.1 3 2.4 3V31h3V18.2c1.3 0 2.4-1 2.4-3V9h-2.4v5h-1.6V9h-1.6v5h-1.8V9H13z" fill="#0A0A0A" />
    {/* cuchillo */}
    <path d="M26 9c2.6 2.2 3 5.4 3 8.4 0 1.8-.4 3-1 4V31h3V9h-5z" fill="#0A0A0A" />
    {mono && <circle cx="9" cy="30.5" r="2" fill="#0A0A0A" />}
  </svg>
);

export default Logo;
